import { ReactNode } from "react"
import { useTranslation } from "react-i18next"
import { useAccountAspect } from "@oysterhr/identity/AccountAspectContext"
import { NarrowPageLayout } from "@oysterhr/feature-components"

import { Heading, Layout, Text } from "@oysterhr/ui"
import { ConfirmExitModal } from "../modals/ConfirmExitModal"
import { useCompanyPaymentsSettingsContext } from "../contexts/CompanyPaymentsSettingsContext"
import { companyPaymentMethodsPath } from "../../../utils/routeHelpers"

interface ConnectPaymentMethodLayoutProps {
  title: string
  subtitle?: string
  children: ReactNode
}

const ConnectPaymentMethodLayout = ({
  title,
  children,
  subtitle,
}: ConnectPaymentMethodLayoutProps) => {
  const { accountAspect: companyId } = useAccountAspect()
  const { paymentsMandateSetup } = useCompanyPaymentsSettingsContext()

  const { t } = useTranslation(
    "company_interface/CompanyPaymentMethodsPage/ConnectPaymentMethodLayout",
  )

  return (
    <Layout variation="wizard" className="bg-gray-100">
      <div className="flex items-center justify-between">
        {paymentsMandateSetup ? (
          <NarrowPageLayout.BackLinkWithConfirmation
            link={companyPaymentMethodsPath(companyId)}
            text={t("backLink")}
            confirmationModal={props => <ConfirmExitModal {...props} />}
          />
        ) : (
          <NarrowPageLayout.BackLink
            link={companyPaymentMethodsPath(companyId)}
            text={t("backLink")}
          />
        )}
      </div>
      <div className="mt-8 text-3xl font-bold">
        <Heading as="h2" className="text-center">
          {title}
        </Heading>
        {subtitle && (
          <Text className="text-center text-base font-normal leading-6 text-gray-400">
            {subtitle}
          </Text>
        )}
      </div>
      <div className="mt-10 flex justify-center gap-8">{children}</div>
    </Layout>
  )
}

export default ConnectPaymentMethodLayout
